import { useRosterContext } from '../contexts/RosterContext';
import { useTargets } from '../contexts/TargetsContext';

/**
 * The targeted combatant's OWN sheet, for what is drawn from its traits (the body plate's figure, plan body-map P2):
 * a statblock has a sheet too, though its tab presents `sourceCharacter` as null so the plain-target modes still
 * trigger. Falls back to the tab's sourceCharacter while the roster's target and the tab disagree.
 *
 * @returns {object | null} the sheet, or null with no target
 */
export default function useTargetFigureSheet() {
  const targeted = useRosterContext().target;
  const { currentTab } = useTargets();
  if (targeted && targeted.id === currentTab?.id) return targeted.sheet;
  return currentTab?.sourceCharacter ?? null;
}
